<section class="section-lg">
			<div class="container">
				<div class="row mt-5 justify-content-md-between justify-content-center align-items-center">
					<div class="col-5">
						<div class="text-center" data-aos="fade-right">
							<img loading="lazy" decoding="async" src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/images/kimba/welcome-kimba.avif" alt="Kimba | Raisoni Education" title="Kimba"
								class="img-fluid" />
						</div>
					</div>
					<div class="col-7">
						<div class="sec-title text-left mt-3" data-aos="zoom-in">
							<h1><span class="fst-italic playfair-display fs-1 fw-bold">Thank You!</span> <br><span class="fs-4"> For Submitting Your Query And  We Will Reply To You <br> Very Soon...</span></h1>
						</div>
						<div class="text-start">
							<a routerLink="/" class="cmn-button">Home Page </a>
						</div>
					</div>
				</div>
			</div>
		</section>